import * as tslib_1 from "tslib";
import React from 'react';
import { useTranslation } from 'react-i18next';
import { DesktopSharePopup } from './DesktopSharePopup';
import { getDeviationShareCodes } from '../helpers';
import { getTranslatedDeviationTitle } from '../../DeviationViews/_helpers';
export var DesktopDeviationSharePopup = function (_a) {
    var deviation = _a.deviation;
    var t = useTranslation().t;
    return (React.createElement(DesktopSharePopup, tslib_1.__assign({ title: getTranslatedDeviationTitle(deviation, t) }, getDeviationShareCodes(deviation))));
};
DesktopDeviationSharePopup.displayName = 'DesktopDeviationSharePopup';
export default DesktopDeviationSharePopup;
//# sourceMappingURL=DesktopDeviationSharePopup.js.map